import { useSubmitPageFilters } from '@/catalog-apps/components/AppPage2/Filter/useSubmitPageFilters'
import { CATALOG_BASE_PATH } from '@/const'
import { cn } from '@/lib/utils'
import { Link, useSearchParams } from 'react-router'
import { StepperStepBody } from './StepperStepBody'
import { useStepperStepContext } from './StepperStepContext'

export function StepNavigate() {
  const [searchParams] = useSearchParams()
  const { submitFilters } = useSubmitPageFilters()
  const { action, contentClassName } = useStepperStepContext()

  if (action.type !== 'navigate') return null

  return (
    <Link
      to={`${CATALOG_BASE_PATH}${action.pageId}?${searchParams.toString()}`}
      onClick={() => {
        if (action.pageFilters) submitFilters(action.pageFilters)
      }}
      className={cn(contentClassName, 'text-foreground')}
    >
      <StepperStepBody />
    </Link>
  )
}
